<ng-content></ng-content>


// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/chips/chips-list/chips-list.component.html